export const PRODUCTION = 'prod';
export const QA = 'qa';
export const DEVELOPMENT = 'dev';
export const MOCK_MODE = 'mock';

// probably not in use anymore
export const DEV_URL = 'dev.telmore.dk';
export const LOCALHOST_URL = 'localhost:3001';
// shop-01
export const SHOP01_URL = 'shop-01.www.test.telmore.dk';
export const TEST61_URL = 'tlmtfro61.telmore.dk';
export const TEST41_URL = 'tlmtfro41.telmore.dk';


export default function useEnvironment () {
  // eslint-disable-next-line complexity
  const getEnvironment = () => {
    // Production env.
    if (process.client) {
      if (((window.location.href).includes('https://www')) || ((window.location.href).includes('http://www'))) {
        return PRODUCTION;
        // Development env.
      } else if ((window.location.href).includes('localhost') || (window.location.href).includes('dev.telmore.dk')) {
        return DEVELOPMENT;
        // QA Env.
      } else {
        return QA;
      }
    } else {
      return QA;
    }
  };

  const isDevEnv = () => getEnvironment() === DEVELOPMENT;
  const isTestEnv = () => getEnvironment() === QA;
  const isProdEnv = () => getEnvironment() === PRODUCTION;

  return {
    isTestEnv,
    isDevEnv,
    isProdEnv,
    getEnvironment
  }
}
